module.exports = __webpack_public_path__ + "static/ad_bg.79131adc.png";